import { render, staticRenderFns } from "./MoveToFinal.vue?vue&type=template&id=478c3fc8&"
import script from "./MoveToFinal.vue?vue&type=script&lang=js&"
export * from "./MoveToFinal.vue?vue&type=script&lang=js&"
import style0 from "./MoveToFinal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports